exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\n  width: 620px;\n  overflow: visible; }\n\n#btn-dropdown-IssueTracker {\n  background-color: #1594A6;\n  display: block; }\n\n#btn-dropdown-projectSelection {\n  background-color: #1594A6;\n  display: block; }\n\n#btn-dropdown-sprintSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.progressBackground {\n  background: #DADADC !important; }\n\n.progressForeground {\n  background: #1594A6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/jira-sync-progress/jira-sync-progress.component.scss
// module id = ../../../../../src/app/components/jira-sync-progress/jira-sync-progress.component.scss
// module chunks = main